<button [ngClass]="{'button-scroll-to-top--show': showScroll}" (click)="scrollToTop()" class="button-scroll-to-top">
  <i class="fa-solid fa-arrow-up"></i> Back to Top
</button>